<div class="help-sub-menu-flyout-card" role="menu">
  @for (item of items(); track item) {
    <ftr-help-sub-menu-flyout-item [item]="item" />
  }
</div>
